/*
 * @Author: your name
 * @Date: 2020-06-29 09:34:55
 * @LastEditTime: 2020-07-07 11:17:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\api\index.js
 */
import request from '@/utils/request'
// 原突泉登录
// export const getLogin = (data) => request({
//     url: '/account/auth',
//     method: 'POST',
//     data
// })
//gps3登录接口
export const getLogin = (data) => request({
    url: '/login',
    method: 'POST',
    data
})

// 获取个人信息
// export const getUserInfo = (token) => request({
//     url: '/account/profile',
//     method: 'get',
//     params: { token }
// })
// 获取当前人的登陆信息
export const getUserInfo=(token) =>  request({
      url: '/getInfo',
      method: 'get',
      params:{ token }
  })
